import { withInstall } from "../util";

import inputNumberVue from "./src/InputNumber.vue";
export const InputNumber = withInstall(inputNumberVue);
